import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { get, map } from 'lodash';
import { getMentoringReviewsForLanding, getMentoringPassCasesForLanding } from 'libs/api/mentoring';
import { useDataApi } from 'libs/hooks';
import { usePagination } from 'libs/hooks';
import { TListResponse, TPagination } from 'modules/types';
import { CWindowWidth } from 'constants/base.const';
import { ERoute } from 'enums/route.enum';
import { Card, Row, Col, List, Button, Badge, Tag, Typography } from 'antd';
import styled from 'styled-components';
import { PrimaryColor, SecondaryColor, device } from 'GlobalStyles';
import blueStar from 'assets/icons/blueStar.webp';
import quoteImage from 'assets/icons/quote.webp';
import starImage from 'assets/icons/star.webp';
import BackgroundBottomSource from 'assets/images/banners/10.webp';

const { Title } = Typography;
const maxWidth = CWindowWidth - 200;

const Reviews = () => {
  const { operation }: any = useParams();

  const MentoringPassCase = () => {
    const [pagination, setPagination] = usePagination(12);

    const reloadPage = (page?: Partial<TPagination>) => {
      setPagination({
        ...pagination,
        ...page,
      });
    };
    const getPromise = getMentoringPassCasesForLanding.bind(null, {
      params: {
        current: pagination.current,
        pageSize: pagination.pageSize,
      },
    });

    const [{ data, loading }, setCallback] = useDataApi(getPromise, {
      contents: [],
    });

    useEffect(() => {
      setCallback(() => getPromise);
    }, [pagination]);

    return (
      <ReviewWrapper>
        <div className='container'>
          <SectionHeader>
            <img
              className='starIcon'
              alt=''
              src={blueStar}
              style={{
                width: '15px',
                display: 'block',
                margin: '0 auto 10px auto',
              }}
            />
            <SectionTitle>합격 사례</SectionTitle>
          </SectionHeader>
          <List
            pagination={{
              ...pagination,
              total: get(data, 'total', 0),
              position: 'bottom',
              showSizeChanger: false,
              onChange: (page) => {
                reloadPage({
                  current: page,
                  pageSize: pagination.pageSize,
                });
              },
            }}
            className='card'
            loading={loading}
            style={{ paddingBottom: '20px', marginTop: '30px', width: '100%' }}
            grid={{ gutter: 16, xs: 1, sm: 2, md: 2, lg: 3, xl: 3, xxl: 3 }}
            dataSource={get(data, 'contents')}
            renderItem={(item) => (
              <List.Item>
                <img alt='' src={quoteImage} />
                <p className='item'>{get(item, 'comment')}</p>
                <p className='footer'>{get(item, 'title')}</p>
              </List.Item>
            )}
          />
        </div>
      </ReviewWrapper>
    );
  };

  const MentoringReview = () => {
    const [pagination, setPagination] = usePagination(15);

    const reloadPage = (page?: Partial<TPagination>) => {
      setPagination({
        ...pagination,
        ...page,
      });
    };

    const getPromise = getMentoringReviewsForLanding.bind(null, {
      params: {
        current: pagination.current,
        pageSize: pagination.pageSize,
      },
    });

    const [{ data, loading }, setCallback] = useDataApi(getPromise, {
      contents: [],
    });

    useEffect(() => {
      setCallback(() => getPromise);
    }, [pagination]);

    return (
      <ReviewWrapper>
        <div className='container'>
          <SectionHeader>
            <img
              className='starIcon'
              alt=''
              src={blueStar}
              style={{
                width: '15px',
                display: 'block',
                margin: '0 auto 10px auto',
              }}
            />
            <SectionTitle>
              멘토링 <span className='strongText'>후기</span>
            </SectionTitle>
          </SectionHeader>

          <List
            pagination={{
              ...pagination,
              total: get(data, 'total', 0),
              position: 'bottom',
              showSizeChanger: false,
              onChange: (page) => {
                reloadPage({
                  current: page,
                  pageSize: pagination.pageSize,
                });
              },
            }}
            className='card'
            loading={loading}
            style={{ paddingBottom: '20px', marginTop: '30px', width: '100%' }}
            grid={{ gutter: 16, xs: 1, sm: 2, md: 2, lg: 3, xl: 3, xxl: 3 }}
            dataSource={get(data, 'contents')}
            renderItem={(item) => (
              <List.Item>
                <p className='item'>{get(item, 'comment')}</p>
                <div style={{ lineHeight: '32px' }}>
                  <span className='footer'>멘티 {get(item, 'mentee')}</span>
                  <StarRate count={get(item, 'score')} />
                </div>
              </List.Item>
            )}
          />
        </div>
      </ReviewWrapper>
    );
  };

  return (
    <>
      {operation === 'pass_review' && <MentoringPassCase />}
      {operation === 'mentoring_review' && <MentoringReview />}
      <BottomWrapper>
        <div className='inner-box'>
          <Title className='title' style={{ marginBottom: '5px', color: '#003159' }}>
            Career Step 회원가입하기
          </Title>
          <div style={{ marginTop: '10px' }}>
            <Link to={ERoute.UserSignup}>
              <Button type='primary'>회원가입</Button>
            </Link>
          </div>
        </div>
      </BottomWrapper>
    </>
  );
};

export default Reviews;

const StarWrapper = styled.div`
  .star {
    width: 14px;
    float: left;
    img {
      vertical-align: none;
    }
  }
`;
const ReviewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 50px;

  @media screen and ${device.lg} {
    padding: 50px 20px;
  }

  .container {
    max-width: 1440px;
    width: 100%;
    margin: 0 auto;
  }

  .item {
    margin-top: 21px;
    font-size: 16px;
    color: #14112a;
    font-weight: bold;
  }

  .footer {
    margin-right: 10px;
    font-size: 14px;
    color: ${SecondaryColor};
    font-weight: bold;
    float: left;
    height: 32px;
  }
`;

const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${PrimaryColor};

  .starIcon {
    width: 15px;
    margin-bottom: 10px;
  }

  .personIcon {
    width: 44px;
    margin: 16px 0 11px 0;
  }

  .strongText {
    color: ${SecondaryColor};
  }
`;

const SectionTitle = styled.div`
  font-size: 24px;
  font-weight: 700;
`;

export const StarRate = ({ count }: { count: number }) => {
  return (
    <StarWrapper>
      {map(Array(count).fill(0), (v) => (
        <div className='star'>
          <img alt='star' src={`${starImage}`} />
        </div>
      ))}
    </StarWrapper>
  );
};

const BottomWrapper = styled.div`
  width: 100%;
  height: 220px;
  padding: 70px 10px;
  background-image: url(${BackgroundBottomSource});
  background-size: cover;

  .inner-box {
    display: block;
    max-width: ${maxWidth}px;
    width: 100%;
    margin: auto;

    .ant-typography {
      color: #ffffff;
    }

    .ant-typography.title {
      @media screen and ${device.md} {
        font-size: 24px;
      }
    }
  }
`;
